<template>
    <div v-show="showLoader" class="loader"><img src="../../assets/images/loader.gif" alt=""></div>  
    
    <!--  Main Start Here  -->
    <main class="main_content">
      <!-- Page Title -->
      <div class="row mb-4 align-items-center">
            <div class="col-md-8">
            <h2 class="page_title">Inquiries</h2>
            </div>
            <div class="col-md-4">
                    <div class="top_btns">
                        <a @click="create_inquiry" class="btn btn-primary">Create Inquiry</a>
                    </div>
            </div>
            
      </div>
      <div class="filter-buttons-tab">
        <button class="tabs-btn active" data-val='3'>New</button>
        <button class="tabs-btn" data-val='1,5'>Active</button>
        <button class="tabs-btn" data-val='56,57'>Archived</button>
    </div>
      <div class="card_box">
        <div class="table_listing">
            <div class="custom_search">
               <div class="row mx-0">
                <div class="col">
                    <div class="form-outline">
                        <input type="text" name="inquiry_id" class="form-control" :class="{ 'active' : inquiry_id }" id="inquiry_id" v-model="inquiry_id" >
                        <label class="form-label" for="inquiry_id">Inquiry #</label>
                    </div>
                </div>

                <div class="col">
                    <div class="form-outline">
                        <input type="text" name="part_number" class="form-control" :class="{ 'active' : part_number }" id="part_number" v-model="part_number">
                        <label class="form-label" for="part_number">Part Number</label>
                    </div>
                </div>
                
                
                <div class="col">
                    <div class="form-outline" >
                        <div :class="{ 'active': from_date }">
                            <datepicker inputFormat="dd-MM-yyyy" class="form-control" v-model="from_date" id="from_date" :clearable="true" :upperLimit="new Date()"/>
                            <label class="form-label" for="from_date">From Date</label>
                        </div>
                    </div>
                </div>

                <div class="col">
                    <div class="form-outline" >
                        <div :class="{ 'active': to_date }">
                            <datepicker inputFormat="dd-MM-yyyy" class="form-control" v-model="to_date" id="to_date"  :clearable="true" :upperLimit="new Date()"/>
                            <label class="form-label" for="to_date">To Date</label>
                        </div>
                    </div>
                </div>

                <div class="col">
                    <button type="submit" class="search_btn" id="search">Search</button>
                </div>

            </div>
          </div>
          <table id="inquires" class="table display" style="width:100%">
            <thead>
              <tr>
                <th>Inquiry ID</th>
                <th>Part Number</th>
                <th>Product Quantity</th>
                <th>Status</th>
                <th>Created On</th>
                <th>Action</th>
              </tr>
            </thead>
            
        </table>
        </div>
      </div>
      
    </main>
</template>
<script>
import $ from "jquery";

import "datatables.net-bs5";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
import Datepicker from 'vue3-datepicker'

import "jszip";
export default {
  return:{
      showLoader: false,
  },
  components: {
    Datepicker,
  },
  data(){
    return{
        
        data_table: '',
        from_date: '',
        to_date: '',
        inquiry_id: '',
        part_number: '',
        active: false,
        API_URL: process.env.VUE_APP_API_URL,
    };
  },
  computed: {
    currentUser() {
        return this.$store.state.auth.user;
    },
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
  },
  mounted() {
      this.getInquiries();
       if (!this.currentUser) {
            this.$router.push('/login');
       }
  },
  methods: {
    logOut() {
        this.$store.dispatch('auth/logout');
        this.$router.push('/login');
    },
    create_inquiry(){
            this.$router.push('/create-inquiry');
    },
    getInquiries() {
       
        this.showLoader = true; 
        
        var access_token = this.currentUser.accessToken;
            $.ajaxSetup({
                headers: {
                    "Authorization": "Bearer "+access_token
                }
            });
           
            $('#inquires').DataTable({
            deferRender: true,
          sDom: 'rtilfp',
          aaSorting: [],
          bFilter: false,
          serverSide: true,
          processing: true,
          loading:true,
          bLengthChange: true,
            lengthMenu: [
                [10, 25, 50, -1],
                [10, 25, 50, "All"]
            ],
            ajax: {
                url: this.API_URL + "customer/inquiries",
                type: "POST",
                // beforeSend: function() {
                //     this.showLoader = true;
                // },
                data: function (d) {
                    d.inquiry_id = $("#inquiry_id").val();
                    d.part_number = $("#part_number").val();
                    d.from_date = $("#from_date").val();
                    d.to_date = $("#to_date").val();
                    d.status = $(".tabs-btn.active").data('val');
                    d.api_token = access_token;
                },
                
            },
            columns: [
                { data: "inquiry_id" },
                { data: "part_number" },
                { data: "product_quantity" },
                { data: "status_html" },
                { data: "created_at" },
                { data: "actions" }
            ],
             columnDefs: [
              { "targets": [ 5 ], orderable: false },
              /*{ "targets": [ 3 ], orderable: false },*/
              { "targets": [ 2 ], orderable: false },
            ],
            });

            $('#inquires').DataTable().on('preXhr.dt', function (e, settings, data) {
                for (let i = 0; i < data.order.length; i++) {
                    var col = data.order[i].column;
                    var dir = data.order[i].dir;
                    data.order_by = data.columns[col].data;
                    data.order_dir = dir;
                }
                this.showLoader = true;
            });

            $('#inquires').DataTable().on('draw', function () {
                this.showLoader = false;
            });

            $('#search').on('click',function () {
                $('#inquires').DataTable().ajax.reload();
            });


            $('.tabs-btn').on('click',function () {
                $(this).parents('.filter-buttons-tab').find('.tabs-btn').removeClass('active');
                $(this).addClass('active');
                $('#inquires').DataTable().ajax.reload();
            });   
                this.showLoader = false;
        
    },
  },
};
</script>